import Vue from 'vue'

Vue.prototype.$global_variable = {
  // demo: '_demo'
  demo: ''
}
